import style from './index.less';
export default ({
    fromu,
    isWap = false,
}: {
    fromu: string;
    registerUcLink: string;
    subuserLoginLink: string;
    isWap?: boolean;
}) => {
    const divideClass = isWap ? style['divide-line-wap'] : style['divide-line-pass'];
    const forgetUrl = isWap
        ? 'https://wappass.baidu.com/v6/getPass?tpl=bceplat&u='
        : 'https://passport.baidu.com/?getpassindex&tpl=bceplat&u=';
    const retrieveUrl = isWap ? '/retrieve-mobile' : '/retrieve';
    return (
        <>
            <div className={style.passContainer}>
                <a className={style.link} href={`${forgetUrl}${fromu}`} target="_blank" rel="noreferrer">
                    忘记密码
                </a>
                <div className={divideClass}></div>
                <a className={style.link} target="_blank" rel="noreferrer" href={retrieveUrl}>
                    忘记账号
                </a>
            </div>
        </>
    );
};
